/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {useState, useEffect} from 'react';

import {
  useGetAemContentQuery,
  useLazyGetSessionDataQuery,
  useLazyGetLookupDataApiQuery
} from '../../redux/services/apiServices';
import {HomePageContentType, HeaderLink} from '../../redux/services/types';
import {LT_MSID_SESSION, NON_PROTECTED_ROUTES} from '../../common/constants';

export default function useAemSessionLookup(
  pathname: string,
  propsProvider: {sessionType: string; domain: string; phdAuthProxyBaseFullURL: string}
) {
  // Use the defined type for aemData
  const {data, isLoading} = useGetAemContentQuery<{data: HomePageContentType; isLoading: boolean}>(
    'getUtahHomePageContent'
  );

  const [headerList, setHeaderList] = useState<HeaderLink[] | undefined>();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState('');
  const [getSessionData, sessionData] = useLazyGetSessionDataQuery();
  const [lookUpDataLoading, setLookupDataLoading] = useState(!sessionData.isError);
  const [getlookupData] = useLazyGetLookupDataApiQuery();

  useEffect(() => {
    if (typeof window !== 'undefined' && propsProvider.sessionType && propsProvider.domain) {
      sessionStorage.setItem('loginType', propsProvider.sessionType);
      sessionStorage.setItem('domain', propsProvider.domain);
      setIsLoggedIn(true);
      if (propsProvider.sessionType === LT_MSID_SESSION) {
        setHeaderList(data?.headerContent?.headerList?.['msid'] ?? []);
      } else {
        setHeaderList(data?.headerContent?.headerList?.['ohid'] ?? []);
      }
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      getSessionData('/api/auth/session');
    }
  }, [propsProvider.sessionType, propsProvider.domain, getSessionData, data?.headerContent?.headerList]);

  useEffect(() => {
    if (sessionData.data?.id) {
      const roleNames = Array.isArray(sessionData.data?.functionRoles) ? sessionData.data.functionRoles.join(',') : '';
      const payeeId: string = sessionData.data?.payeeId;
      setLoggedInUser(`${sessionData?.data?.firstName ?? ''} ${sessionData?.data?.lastName ?? ''}`);
      if (roleNames) {
        const lookupPath = `/api/authproxy/auth/v1/permissions/lookup/resource?roleIds=${roleNames}`;
        getlookupData({lookupPath, headerList: headerList ?? [], payeeId})
          .then(() => {
            setLookupDataLoading(false);
          })
          .catch(() => {
            setLookupDataLoading(false);
          });
      } else {
        setLookupDataLoading(false);
      }
    }
  }, [getlookupData, propsProvider.sessionType, propsProvider.phdAuthProxyBaseFullURL, sessionData.data, headerList]);

  return {
    data,
    isLoading: NON_PROTECTED_ROUTES.includes(pathname) ? isLoading : lookUpDataLoading,
    isLoggedIn,
    headerList,
    loggedInUser
  };
}
